import { useScrollReveal } from '@/hooks/useScrollReveal';

const directors = [
  { name: 'DOCINETE CARVALHO', role: 'Presidente', image: '/images/diretores/docinete-carvalho.jpg' },
  { name: 'DALTON LUIZ SILVA', role: 'Vice Presidente', image: '/images/diretores/dalton-luiz.jpg' },
  { name: 'WALDECIR SOUSA', role: 'Secretário Geral', image: '/images/diretores/waldecir.jpg' },
  { name: 'LEIDIANE DIAS', role: 'Tesoureira', image: '/images/diretores/leidiane-dias.jpg' },
  { name: 'RUDIERISON ALMEIDA', role: 'Pres. Conselho Fiscal', image: '/images/diretores/rudierison.jpg', imgStyle: { backgroundPosition: '50% 12%' } },
  { name: 'MARIA OCILENE GOMES', role: 'Dir. Relações Públicas', image: '/images/diretores/maria-ocilene.jpg' },
  { name: 'LEANDRO JUNIOR', role: 'Coordenação de Base', image: '/images/diretores/leandro.jpg' },
  { name: 'ISRAEL PINTO GOMES', role: 'Diretor de Logística', image: '/images/diretores/israel-pinto.jpg', imgStyle: { backgroundPosition: '50% 25%', backgroundSize: '220%' } },
  { name: 'DR. GILSON COSTA', role: 'Advogado / Setor Jurídico', image: '/images/diretores/gilson-costa.jpg' },
];

export default function Directors() {
  const [ref, vis] = useScrollReveal();

  return (
    <section id="diretores" data-testid="directors-section" className="py-20 sm:py-28 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center mb-14 transition-all duration-800 ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block px-4 py-1.5 bg-[#1A8C7A]/10 text-[#1A8C7A] text-xs font-bold tracking-wider uppercase rounded-full mb-4">
            Diretoria
          </span>
          <h2
            data-testid="directors-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1A1A2E] mb-4"
            style={{ letterSpacing: '-0.02em' }}
          >
            CONHEÇA NOSSO TIME DE <span className="text-[#1A8C7A]">DIRETORES</span>
          </h2>
          <div className="w-20 h-1 bg-[#E8621A] mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {directors.map((d, i) => (
            <DirectorCard key={i} director={d} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}

function DirectorCard({ director, delay }) {
  const [ref, vis] = useScrollReveal(0.2);

  const bgStyle = director.imgStyle ? {
    backgroundImage: `url(${director.image})`,
    backgroundSize: director.imgStyle.backgroundSize || '350%',
    backgroundPosition: director.imgStyle.backgroundPosition || 'center 20%',
  } : null;

  return (
    <div
      ref={ref}
      data-testid={`director-${director.name.toLowerCase().replace(/\s+/g, '-').replace(/\./g, '').slice(0, 20)}`}
      className={`director-card relative bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100
        transition-all duration-700 ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="p-6 flex flex-col items-center text-center">
        <div className="w-28 h-28 rounded-full overflow-hidden mb-5 border-4 border-[#1A8C7A]/20 shadow-md">
          {bgStyle ? (
            <div className="w-full h-full" style={bgStyle} role="img" aria-label={director.name} />
          ) : (
            <img
              src={director.image}
              alt={director.name}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = `<div class="w-full h-full bg-[#1A8C7A] flex items-center justify-center text-white text-3xl font-bold">${director.name.charAt(0)}</div>`;
              }}
            />
          )}
        </div>
        <h3 className="text-sm sm:text-base font-bold text-[#1A1A2E] mb-1">{director.name}</h3>
        <p className="text-xs sm:text-sm text-[#E8621A] font-semibold">{director.role}</p>
      </div>
    </div>
  );
}
